"use client";

import { FC } from "react";
import { cn } from "@/lib/utils";
import { ProgramStructure2Data } from "./_schema";
import Image from "next/image";

export const DownloadButton: FC<{
    parsedData: ProgramStructure2Data;
    onClick: () => void;
}> = ({ parsedData, onClick }) => (
    <div className={cn(
        "flex justify-center items-center w-full",
        "mt-[24px]",
        "sm:mt-[20px]",
        "md:mt-[28px]",
        "lg:mt-[32px]",
        "xl:mt-[32px]"
    )}>
        <button
            data-cta-name="download_brochure"
            onClick={onClick}
            className={cn(
                "btn-base btn-white flex items-center justify-center",
                "w-full",
                "sm:w-auto sm:inline-flex",
                "gap-[0px]",
                "sm:gap-[7.5px]",
                "md:gap-[10px]",
                "lg:gap-[10px]",
                "xl:gap-[10px]"
            )}
            style={{
                backgroundColor: parsedData.cta_button_background_color || "#FFFFFF",
                color: parsedData.cta_button_text_color || "#222222"
            }}
        >
            <span>{parsedData.cta_button_text}</span>
            {parsedData.cta_button_icon && (
                <div className={cn(
                    "hidden items-center justify-center",
                    "sm:flex sm:size-[18px]",
                    "md:flex md:size-[24px]",
                    "lg:flex lg:size-[24px]",
                    "xl:flex xl:size-[24px]"
                )}>
                    <div className="rotate-90 flex items-center justify-center">
                        <Image
                            src={parsedData.cta_button_icon}
                            alt={parsedData.cta_button_icon_alt || "Download"}
                            width={24}
                            height={24}
                            className={cn(
                                "object-contain",
                                "sm:w-[18px] sm:h-[18px]",
                                "md:w-[24px] md:h-[24px]",
                                "lg:w-[24px] lg:h-[24px]",
                                "xl:w-[24px] xl:h-[24px]"
                            )}
                        />
                    </div>
                </div>
            )}
        </button>
    </div>
);